import { useTranslation } from 'react-i18next';
import { Analysis, IGetEffectReportDetailsResp, Topic } from '../../../services/reports';
import { convertTypeString, HIGH_SCORE, LOW_SCORE } from '../../helpers';

const calculateAverage = (arr: number[]) => {
  const sum = arr.reduce((acc, value) => acc + value, 0);
  const average = sum / arr.length;
  return parseFloat(average.toFixed(1));
};

const useInsightsChartData = (
  data: {
    clarity?: Analysis;
    quality?: Analysis;
    relationship?: Analysis;
    behaving?: Analysis;
    learning?: Analysis;
  },
  effectData: IGetEffectReportDetailsResp | null
) => {
  const { t } = useTranslation();

  const desiredOrder = [
    t('report.effect.topics.five.clarity'),
    t('report.effect.topics.five.quality'),
    t('report.effect.topics.five.relationship'),
    t('report.effect.topics.five.behaving'),
    t('report.effect.topics.five.learning'),
  ];

  const chartData = Object.values(data).map(item => {
    const averageValues = item.included_topics
      .map(code => {
        const matchingTopic = effectData?.topics.find(topic => topic.code === code);
        return matchingTopic ? matchingTopic.average_value : 0;
      })
      .filter(value => value !== 0);

    const averageValue = averageValues.length > 0 ? calculateAverage(averageValues) : 0;

    return {
      challenge: t(`report.effect.topics.five.${convertTypeString(item.type)}`),
      low: LOW_SCORE,
      high: HIGH_SCORE,
      value: averageValue,
    };
  });

  return chartData.sort(
    (a, b) => desiredOrder.indexOf(a.challenge) - desiredOrder.indexOf(b.challenge)
  );
};

export default useInsightsChartData;
